import { render, staticRenderFns } from "./button-switch.component.vue?vue&type=template&id=4dd3b0e5&scoped=true&lang=pug"
import script from "./button-switch.component.vue?vue&type=script&lang=ts"
export * from "./button-switch.component.vue?vue&type=script&lang=ts"
import style0 from "./button-switch.component.vue?vue&type=style&index=0&id=4dd3b0e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3b0e5",
  null
  
)

export default component.exports